import { useGetValidatorTotalRewards } from '../../../hooks/event-store-hooks';
import { Validator } from '@block-explorer/entities';

export enum ValidatorType {
  ACTIVE_VALIDATOR = 'active_validator',
  PAST_VALIDATOR = 'past_validator',
  PENDING_VALIDATOR = 'pending_validator',
  ACTIVE_VALIDATOR_BID = 'active_bidder',
  INACTIVE_VALIDATOR_BID = 'inactive_bidder',
}

interface ValidatorAccountDetailsHook {
  validatorStakedBalance: number | undefined;
  validatorTotalReward: string | null;
  validatorTotalRewardLoading: boolean;
  validatorTotalRewardError: string | null;
}

export const useGetValidatorAccountDetails = (
  publicKey: string,
  validator: Validator | null,
  validatorType: string | undefined
): ValidatorAccountDetailsHook => {
  const {
    data: validatorTotalReward,
    loading: validatorTotalRewardLoading,
    error: validatorTotalRewardError,
  } = useGetValidatorTotalRewards({
    publicKey,
  });

  if ((!validator || !validatorType) && validatorTotalReward) {
    return {
      validatorStakedBalance: 0,
      validatorTotalReward: validatorTotalReward.data,
      validatorTotalRewardLoading,
      validatorTotalRewardError,
    };
  }

  if (!validator || !validatorTotalReward || !validatorType) {
    return {
      validatorStakedBalance: 0,
      validatorTotalReward: null,
      validatorTotalRewardLoading,
      validatorTotalRewardError,
    };
  }

  return {
    validatorStakedBalance: validator.bidAmount,
    validatorTotalReward: validatorTotalReward.data,
    validatorTotalRewardLoading,
    validatorTotalRewardError,
  };
};
